export default __webpack_public_path__ + "static/media/0013.1de13fcf.WAV";